export default function getOptions(loaderContext) {
    return loaderContext.options;
}
